import { post } from "../utils/backend";
import { getMockData, mock } from "./mock/Mock";
import { GetUploadTicketParamDTO, OssUploadTicketDTO } from "./OssType";

const getUploadTicket = async (param: GetUploadTicketParamDTO): Promise<OssUploadTicketDTO | null> => {
    if (mock) {
        return getMockData("getUploadTicket");
    }
    const resultOrErrorCode = await post<GetUploadTicketParamDTO, OssUploadTicketDTO>(
        "/oss/getUploadTicket",
        param
    );
    if (typeof resultOrErrorCode === "string") {
        return null;
    }
    return resultOrErrorCode;
};

export const OssApi = {
    getUploadTicket,
};
